<template>
  <select
    style="color: #DCDCDC;font-weight:normal"
    class="locale"
    v-model="selected"
    @change="onChange()"
    v-on:change="language_change"
  >
    <option disabled value="locale">{{ $t("locales.lang") }}</option>
    <option value="en">{{ $t("locales.en") }}</option>
    <option value="gu">{{ $t("locales.gu") }}</option>
    <option value="pt">{{ $t("locales.pt") }}</option>
    <option value="ru">{{ $t("locales.ru") }}</option>
    <option value="es">{{ $t("locales.es") }}</option>
    <option value="hi">{{ $t("locales.hi") }}</option>
  </select>
</template>

<script>
import { saveLocale } from "../services/firebase";
export default {
  name: "selectLocale",
  props: ["payload"],
  data() {
    return {
      selected: this.$store.state.locale,
    };
  },
  methods: {
    onChange() {
      if (this.$store.state.profile.uid) {
        // console.log(this.selected);
        this.$store.dispatch("setLocale", this.selected);
        this.$store.state.locale = this.selected;
        this.$i18n.locale = this.selected;
        saveLocale(this.$store.state.profile.uid, this.selected, function(
          error
        ) {
          if (!error) {
            //alert(i18n.t("alertText.uploadFail"));
          }
        },this.$store.state.logout_count,this.$store.state.last_logout);
      } else {
        this.$store.dispatch("setLocale", this.selected);
        this.$store.state.locale = this.selected;
        this.$i18n.locale = this.selected;
      }
    },
    language_change() {
      // console.log("------------",this.$route.path)
      if (this.$route.path === "/") {
        this.$router.go();
      }
    },
  },
  mounted() {
    this.onChange();
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
};
</script>
